import { TipoTurmaCertificacao } from 'src/tipos'

export const OPCOES_TIPO = [
  {
    id: TipoTurmaCertificacao[TipoTurmaCertificacao.Aberta],
    texto: TipoTurmaCertificacao[TipoTurmaCertificacao.Aberta]
  },
  {
    id: TipoTurmaCertificacao[TipoTurmaCertificacao.Fechada],
    texto: TipoTurmaCertificacao[TipoTurmaCertificacao.Fechada]
  },
  {
    id: 'Todas',
    texto: 'Todas'
  }
]
